import BadgesValueV2 from "../BadgesValueV2";
import PredictorBadgeRequirements from "./PredictorBadgeRequirements";

export default class PredictorBadgesValue extends BadgesValueV2 {
  public requirements: PredictorBadgeRequirements =
    new PredictorBadgeRequirements();
}
